import {TextComponent} from '../text/TextComponent'

class ParagraphComponent extends TextComponent {
    render($$) {
        return super.render($$, {
            textClassName: 'dw-text-paragraph',
            labelClassName: '',
            shortLabel: this.getLabel('paragraph.short'),
            longLabel: this.getLabel('paragraph')
        })
    }
}

export {ParagraphComponent}
